import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import logo from "../assets/icons/cblifelogo.png";
import { drawerWidth, getSidebarNavGroups } from "../config/sidebarNav";

const NavItem = ({ item }) => {
  const IconComponent = item.muiIcon;

  return (
    <NavLink
      to={item.to}
      className={({ isActive }) =>
        isActive ? "nav-link nav-link-active" : "nav-link"
      }
    >
      <ListItem disablePadding className="sidebar-nav-item">
        <ListItemButton className="sidebar-nav-button">
          <ListItemIcon className="sidebar-nav-icon-wrap">
            {IconComponent ? (
              <IconComponent className="sidebar-mui-icon" />
            ) : (
              <img
                src={item.icon}
                className="nav-link-icon"
                alt={item.alt}
              />
            )}
          </ListItemIcon>
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{ className: "sidebar-nav-label" }}
          />
        </ListItemButton>
      </ListItem>
    </NavLink>
  );
};

const SideBar = ({
  handleDrawerClose,
  open,
  moduleKeys,
  catalog,
  registeredModuleKeys,
}) => {
  const groups = getSidebarNavGroups(
    moduleKeys,
    catalog,
    registeredModuleKeys
  );

  return (
    <Drawer
      className="sidebar-drawer"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <Box className="sidebar-inner">
        <Box className="sidebar-brand">
          <img src={logo} alt="CB Life" className="sidebar-brand-logo" />
          <Box className="sidebar-brand-text">
            <Typography className="sidebar-brand-title">CB Life</Typography>
            <Typography className="sidebar-brand-subtitle">
              Insurance Company Ltd.
            </Typography>
          </Box>
        </Box>

        <Box className="sidebar-nav-scroll">
          {groups.map((group) => (
            <section key={group.title} className="sidebar-section">
              <Typography component="h2" className="sidebar-section-title">
                {group.title}
              </Typography>
              <List disablePadding className="sidebar-nav-list">
                {group.items.map((item) => (
                  <NavItem key={item.to} item={item} />
                ))}
              </List>
            </section>
          ))}
        </Box>

        <button
          type="button"
          className="sidebar-collapse-btn"
          onClick={handleDrawerClose}
          aria-label="Collapse sidebar"
        >
          <span className="sidebar-collapse-icon">&laquo;</span>
          <span>Collapse</span>
        </button>
      </Box>
    </Drawer>
  );
};

export default SideBar;
